/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';
import { JOB_DETAIL_FIELDS } from '../../fragments';

export const GET_JOB_BY_ID = gql`
  ${JOB_DETAIL_FIELDS}
  query GetJobById($jobId:ID!){
    jobById(jobId:$jobId){
      ...JobDetailFields
    }
  }
`;
